export type PublicConfig = {
  siteUrl: string;
  supabaseUrl: string;
  supabaseAnonKey: string;
  posthogProjectKey: string;
  posthogHost: string;
  professionalMonthlyPrice: number;
};

export function publicConfig(): PublicConfig {
  const runtime = window.ORIVON_CONFIG || {};
  return {
    siteUrl: import.meta.env.VITE_SITE_URL || runtime.siteUrl || window.location.origin,
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL || runtime.supabaseUrl || '',
    supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || runtime.supabaseAnonKey || '',
    posthogProjectKey:
      import.meta.env.VITE_POSTHOG_KEY || runtime.posthogProjectKey || '',
    posthogHost:
      import.meta.env.VITE_POSTHOG_HOST || runtime.posthogHost || 'https://us.i.posthog.com',
    professionalMonthlyPrice: runtime.professionalMonthlyPrice || 14.9
  };
}

export function hasSupabaseConfig(): boolean {
  const config = publicConfig();
  return Boolean(config.supabaseUrl && config.supabaseAnonKey);
}
